import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Messages } from '@core/constants/messages.const';
import { SharedModule } from '@core/modules/shared.module';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent {
  public dialogRef = inject(MatDialogRef<LogoutComponent>);

  heading: string = Messages.NewVersionUpdateHeading;
  message: string = Messages.NewVersionUpdateMessage;

  handleClose = (): void => {
    this.dialogRef.close(true);
  };
}

